<template>
    <div v-if="isShowMultiMonitorTag" class="multi-monitor-trigger-tag">
        <div class="multi-monitor-trigger-tag__container">
            <div class="multi-monitor-trigger-tag__container__main">
                <div class="multi-monitor-trigger-tag__container__title">
                    {{ multiMonitorTagType === 'parent' ? $t('patent-view.multiMonitor.parent') : $t('patent-view.multiMonitor.child') }}
                </div>
                <template v-if="multiMonitorTagType === 'parent'">
                    <div
                        :class="{ 'multi-monitor-trigger-tag__container__button': true, 'multi-monitor-trigger-tag__container__button--disabled': isReachLimit }"
                        @click="openChild"
                    >
                        <PtIcon icon="SolidMore" />
                        <span>{{ `${$t('patent-view.multiMonitor.addChild')}(${MultiMonitorServiceInstance.childrenList.length}/${MultiMonitorServiceInstance.limit})` }}</span>
                    </div>
                    <div class="multi-monitor-trigger-tag__container__button" @click="exitParent">
                        <PtIcon icon="SolidCloseBig" />
                        <span>{{ $t('patent-view.multiMonitor.exitFromParent') }}</span>
                    </div>
                </template>
                <div v-else class="multi-monitor-trigger-tag__container__button" @click="exitChild">
                    <PtIcon icon="SolidCloseBig" />
                    <span>{{ $t('patent-view.multiMonitor.exitFromChild') }}</span>
                </div>
            </div>
            <div v-if="MultiMonitorServiceInstance.isParentActive" class="multi-monitor-trigger-tag__container__tip">
                <PtIcon icon="SolidHelpCenterLine" />
                <span>{{ $t('patent-view.multiMonitor.userTip') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/more.svg';
import '@patsnap-ui/icon/assets/solid/HelpCenterLine.svg';
import MultiMonitorServiceInstance from './multi-monitor-service';
import { getQueryString } from './utils';
import { usePatentsList } from '@/views/side-function-bar/patents-list/composables/use-patents-list';

export default {
    name: 'MultiMonitorTag',
    components: {
        PtIcon: Icon,
    },
    setup() {
        const { setPatentListVisible } = usePatentsList();

        return {
            setPatentListVisible,
        };
    },
    data() {
        return {
            MultiMonitorServiceInstance,
        };
    },
    computed: {
        isShowMultiMonitorTag() {
            return MultiMonitorServiceInstance.isChild || MultiMonitorServiceInstance.isParentActive;
        },
        multiMonitorTagType() {
            if (MultiMonitorServiceInstance.isParentActive) return 'parent';
            if (MultiMonitorServiceInstance.isChild) return 'child';
            return '';
        },
        isReachLimit() {
            return MultiMonitorServiceInstance.childrenList.length >= MultiMonitorServiceInstance.limit;
        },
    },
    created() {
        const childToggleCallback = patentId => this.$router.push({ ...this.$route, query: { ...this.$route.query, patentId } });
        MultiMonitorServiceInstance.init(this.$router, childToggleCallback);
        // 如果是子窗口，默认关闭右侧
        if (MultiMonitorServiceInstance.child__hasUrlMark()) this.setPatentListVisible(false);
        // 监听路由变化，路由变化后需要切换子窗口
        this.routerAfterEachHook = this.$router.afterEach((to, from) => {
            if (!MultiMonitorServiceInstance.isParentActive) return;
            const fromId = _.get(from, 'query.patentId');
            const toId = _.get(to, 'query.patentId');
            if (fromId && toId && (fromId !== toId)) {
                MultiMonitorServiceInstance.parent__triggerChildToggleCallback(toId);
                window.rvTrack('MultiMode Toggle Children Patent');
            }
        });
    },
    beforeDestroy() {
        this.routerAfterEachHook && this.routerAfterEachHook();
    },
    methods: {
        openChild() {
            const patentId = MultiMonitorServiceInstance.activeId || _.get(this.$route, 'query.patentId');
            const queryString = getQueryString(patentId);
            const path = '/abst';
            if (!patentId || !path || this.isReachLimit) return;
            MultiMonitorServiceInstance.parent__openNewWindow(path, queryString);
            window.rvTrack('MultiMode Open New Window');
        },
        exitParent() {
            MultiMonitorServiceInstance.parent__exit();
        },
        exitChild() {
            MultiMonitorServiceInstance.child__exit();
        },
    },
};
</script>

<style lang="scss">
.multi-monitor-trigger-tag {
    width: 100%;
    height: 4px;
    background-color: $status-success-primary;
    position: fixed;
    top: 60px;
    left: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .multi-monitor-trigger-tag__container {
        padding: 2px 4px;
        border-radius: 4px 4px 0 0;
        background-color: $status-success-primary;
        color: #fff;
        .multi-monitor-trigger-tag__container__main {
            display: flex;
            align-items: center;
            justify-content: center;
            .multi-monitor-trigger-tag__container__title {
                font-size: 12px;
                padding: 0 8px;
                margin-right: 8px;
                flex-shrink: 0;
            }
            .multi-monitor-trigger-tag__container__button {
                flex-shrink: 0;
                color: #fff;
                padding: 1px 8px 1px 0;
                border-radius: 4px;
                cursor: pointer;
                background-color: $status-success-hover;
                margin-right: 4px;
                .patsnap-biz-icon {
                    font-size: 22px;
                    color: #fff;
                    margin-bottom: 0;
                }
                span {
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 12px;
                }
                &:hover {
                    background-color: $status-success-clicked;
                }
                &:last-of-type {
                    margin-right: 0;
                }
                &--disabled {
                    background-color: transparent !important;
                    cursor: not-allowed;
                    color: $status-success-disable;
                    .patsnap-biz-icon {
                        color: $status-success-disable;
                    }
                }
            }
        }
        .multi-monitor-trigger-tag__container__tip {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            padding: 0 8px;
            color: rgba(255, 255, 255, 0.7);
            .patsnap-biz-icon {
                font-size: 22px;
                color: rgba(255, 255, 255, 0.7);
                margin-bottom: 0;
            }
        }
    }
}
</style>
